module.exports = __webpack_public_path__ + "img/img7.a2b867fb.png";